
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/taxas-conversao",
      function () {
        return require("private-next-pages/taxas-conversao/index.js");
      }
    ]);
  